import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

/** Принудительно помещаем в один chunk с ProductsDashboard, так как используется только на той странице */
const ImportProductsFromExcelLazy = loadable(
    () => import(/* webpackChunkName: "ProductsDashboard" */ './ImportProductsFromExcel')
);

export const ImportProductsFromExcelAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <ImportProductsFromExcelLazy />
    </DelayedSuspense>
);
